<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述：管理员列表
    -->
	<div class="addadmin">
		<el-button type="info" class="addbutton" @click="addadmin()">增加管理员</el-button>
		<el-form :inline="true" :model="list" class="demo-form-inline" @keyup.enter.native="seach">
			<el-form-item label="账号">
				<el-input v-model="list.account" placeholder="账号"></el-input>
			</el-form-item>
			<el-form-item label="真实姓名">
				<el-input v-model="list.real_name" placeholder="真实姓名"  :maxlength="11"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="seach" @keyup.enter.native="seach">查询</el-button>
				<el-button type="primary" @click="resetting">重置</el-button>
			</el-form-item>
		</el-form>
		<!---->
		<el-table :data="listend" border style="width:1652px;text-align:center;margin-bottom: 10px;font-size:12px;">
    		<!--<el-table-column prop="admin_id" label="管理员Id" align="center">
			</el-table-column>-->
			<el-table-column prop="account" label="账号" align="center">
			</el-table-column>,.
			<el-table-column prop="real_name" label="真实姓名" align="center">
			</el-table-column>
			<el-table-column prop="phone" label="手机号" align="center">
			</el-table-column>
			<el-table-column prop="create_time" label="创建时间" align="center">
			</el-table-column>
			<el-table-column label="状态" align="center">
				<template scope="scope">
		        <el-tag v-if="0 == scope.row.status" type="danger">禁用</el-tag>
		        <el-tag v-if="1 == scope.row.status" type="primary">正常</el-tag>
	      	</template>
			</el-table-column>
			<el-table-column prop="sumbit" label="操作" align="center">
				<template scope="scope">		
						<el-button  type="primary"  size="mini" @click="changeAdd(scope.row)">修改</el-button>
						<el-button  type="primary"  size="mini" @click="routerCode(scope.row)">表</el-button>
						<el-button 	type="primary"  size="mini" @click="routerPw(scope.row)">密码</el-button>
						<el-button 	type="primary"  size="mini" @click="routerMenu(scope.row)">菜单</el-button>
						 <el-button type="danger" size="mini" @click="deldata(scope.row)">删除</el-button>
				</template>
			</el-table-column>
			
		</el-table>
		 <el-pagination
			 	@size-change="handleSizeChange"
	      		@current-change="handleCurrentChange"
			 	:page-size="pageSize"
			    layout="total,prev, pager, next"
			    :total="total"
		      >
		    </el-pagination>
		<addAd v-if="addAd" v-on:pagetrue="pagefalse" v-on:addAdminTrue="addAdminfalse"></addAd>
		<changeAd v-if="changead" v-on:pagechangefalse="pageaddfalse" v-bind:id="adminId"></changeAd>
		<addCode v-if="addcode"  v-on:changeCodefalse="Codefalse"></addCode>
		<changeAdpw v-if="changeAdPw" v-on:changepwfalse="pwfalse" v-bind:adpw="adminId"></changeAdpw>
		<addMenu v-if="addmenu" v-on:changeMenuFalse="menufalse" v-bind:addmenu="adminId"></addMenu>
	</div>
</template>

<script>
	import { mapMutations, mapState } from 'vuex'
	import addAd from '@/components/addAd'
	import changeAd from '@/components/changeAdmin'
	import addCode from '@/components/addCode'
	import changeAdpw from '@/components/changeAdPw'
	import addMenu from '@/components/addMenu'
	export default{
		name:'add-admin',
		data(){
			return{
				addAd:false,
				changead:false,
				addcode:false,
				changeAdPw:false,
				pwFalse:false,
				addmenu:false,
				list:{
					id:'',
					account:'',
					real_name:'',
				},
				listend:[],
				numofid:0,
				adminId:'',
				total:0,
				pageSize:15,
			}
		},
		mounted:function(){
			this.seach()
		},
		methods:{
			seach(){
				const account = this.list.account
				const realName = this.list.real_name
				this.$jssdk.admin.list(
					{account:account,real_name:realName},(data) =>{
					this.listend = data.list.data
					this.total = data.list.total
				})
			},
			resetting(){
				this.list.account = ''
				this.list.real_name = ''
			},
			addadmin(){
				this.addAd = true
			},
			pagefalse(){
				this.addAd = false
				return
			},
			addAdminfalse(){
				this.addAd = false
				this.seach()
				return
			},
			deldata({account,admin_id}){
				this.$confirm(`确认删除管理员账号${account}吗?`,{
					confirmButtonText:'确定',
					cancelButtonText:'取消',
				}).then(_ => {
					this.$jssdk.admin.delete({admin_id},(data) =>{
						console.log(data)
						this.$message.success('删除成功')
						this.seach()
						return
					}),(err)=>{
						 this.$message.warning(err.msg)
						 return
					}
				})
			},
			//修改详情
			changeAdd($index){
				this.adminId = $index
				this.changead = true
			},
			pageaddfalse(){
				this.changead = false
				this.seach()
				return
			},
			//修改电表
			routerCode({admin_id}){
				this.adminId = {admin_id}
				this.addcode = true
				this.setadminId({
					adminId:this.adminId.admin_id
				})
				
			},
			Codefalse(){
				this.addcode = false
			},
			//修改密码
			routerPw({admin_id}){
				this.adminId = {admin_id}
				this.changeAdPw = true
			},
			pwfalse(){
				this.changeAdPw = false	
			},
			//修改菜单
			routerMenu({admin_id}){
				this.adminId = {admin_id}
				this.addmenu = true
			},
			menufalse(){
				this.addmenu = false
			},
			//分页
			handleSizeChange(val) {
		    },
		     handleCurrentChange(val) {
		     	const account = this.list.account
				const realName = this.list.real_name
				this.$jssdk.admin.list(
					{account:account,real_name:realName,page:val},(data) =>{
					this.listend = data.list.data
				})
		    },
			...mapMutations(['setadminId'])
		},
		components:{
				addAd,
				changeAd,
				addCode,
				changeAdpw,
				addMenu,
		},
	}
</script>

<style>
	.addbutton{
		margin-bottom: 20px !important;
	}
	
</style>


// WEBPACK FOOTER //
// AddAdmin.vue?3b2de90a